import Loader from "@src/components/Loader/Loader";
import useRedirectIfAuthenticated from "@src/hooks/useRedirectIfAuthenticated";
import Page from "@src/layout/Page";
import { useUserStore } from "@src/stores/userStore";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const Logout = () => {
    const navigate = useNavigate()
    const logout = useUserStore((state) => state.logout);
    useEffect(() => {
        logout();
        navigate("/");
    }, [])
    return (
        <Page>
            <Loader />
            Logging you out...
        </Page>
    );
};
export default Logout;
